// Error types
export class CadopError extends Error {
    constructor(message, code, details) {
        super(message);
        this.code = code;
        this.details = details;
        this.name = 'CadopError';
    }
}
// Error code definition
export var CadopErrorCode;
(function (CadopErrorCode) {
    // Basic error
    CadopErrorCode["NOT_SUPPORTED"] = "NOT_SUPPORTED";
    CadopErrorCode["INVALID_STATE"] = "INVALID_STATE";
    CadopErrorCode["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    CadopErrorCode["NOT_FOUND"] = "NOT_FOUND";
    // Registration related
    CadopErrorCode["REGISTRATION_FAILED"] = "REGISTRATION_FAILED";
    CadopErrorCode["DUPLICATE_REGISTRATION"] = "DUPLICATE_REGISTRATION";
    // Authentication related
    CadopErrorCode["AUTHENTICATION_FAILED"] = "AUTHENTICATION_FAILED";
    CadopErrorCode["INVALID_CREDENTIAL"] = "INVALID_CREDENTIAL";
    CadopErrorCode["AUTHENTICATOR_NOT_FOUND"] = "AUTHENTICATOR_NOT_FOUND";
    // Challenge related
    CadopErrorCode["INVALID_CHALLENGE"] = "INVALID_CHALLENGE";
    CadopErrorCode["CHALLENGE_EXPIRED"] = "CHALLENGE_EXPIRED";
    // User related
    CadopErrorCode["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    CadopErrorCode["USER_CANCELLED"] = "USER_CANCELLED";
    // System error
    CadopErrorCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    CadopErrorCode["DATABASE_ERROR"] = "DATABASE_ERROR";
    CadopErrorCode["REMOVE_DEVICE_FAILED"] = "REMOVE_DEVICE_FAILED";
    // Token related errors
    CadopErrorCode["TOKEN_EXPIRED"] = "TOKEN_EXPIRED";
    CadopErrorCode["TOKEN_INVALID_SIGNATURE"] = "TOKEN_INVALID_SIGNATURE";
    CadopErrorCode["TOKEN_INVALID_AUDIENCE"] = "TOKEN_INVALID_AUDIENCE";
    CadopErrorCode["TOKEN_INVALID_ISSUER"] = "TOKEN_INVALID_ISSUER";
    CadopErrorCode["TOKEN_INVALID_CLAIMS"] = "TOKEN_INVALID_CLAIMS";
    CadopErrorCode["TOKEN_PUBLIC_KEY_MISMATCH"] = "TOKEN_PUBLIC_KEY_MISMATCH";
})(CadopErrorCode || (CadopErrorCode = {}));
//# sourceMappingURL=errors.js.map